/* eslint-disable */
import React,{ useState, useEffect} from "react";
import {
  Button,
  Modal,
  ModalBody,
  Input,
  Form,
  Row,
  Col,
  FormGroup,
  Label,
  InputGroup,
  InputGroupAddon,
  ModalHeader,
  ModalFooter,
} from "reactstrap";
import Validator from "../../utils/validator";
import bgimg from "../../assets/images/ui/welcome.png";
import { useTranslation } from "react-i18next";


const ForgetModal = (props) => {
  const { t } = useTranslation();
  let { forgetModal } = props.state;

  let COUNTDOWN_SECONDS = 60;
  // 计时中标识
  const [timing, setTiming] = useState(props.start);
  // 当前秒数
  const [second, setSecond] = useState(COUNTDOWN_SECONDS);

  const [email, setEmail] = useState({
    status: "",
    msg: "",
    value: "",
  });

  const [vcode, setVcode] = useState({
    status: "",
    msg: "",
    value: "",
  });

  const [isNotice, setIsNotice] = useState(false);
  const [notice, setNotice] = useState("");
  const isNoticeToggle = (e) => {
    e.preventDefault();
    setIsNotice(!isNotice);
  };

  const toggle = () => {
    props.dispatch({
      type: "layout/save",
      payload: {
        forgetModal: false,
      },
    });
  };

  const preventJump = (e) => {
    e.preventDefault();
    toggle();
  };
  // 处理表单输入
  const onChange = (elmName, event) => {
    switch (elmName) {
      case "email":
        setEmail({
          status: "",
          msg: "",
          value: event.target.value,
        });
        break;
      case "vcode":
        setVcode({
          status: "",
          msg: "",
          value: event.target.value,
        });
    }
  };

  //  失去焦点
  const onBlur = (elmName, event) => {
    switch (elmName) {
      case "email":
        verifyEmail(event.target.value);
        break;
      case "vcode":
        verifyCode(event.target.value);
    }
  };

  //  验证表单
  const verifyEmail = (email) => {
    if (!email) {
      setEmail({
        status: "danger",
        msg: t("Email is required!"),
      });
      return false;
    }

    if (!Validator.isEmail(email)) {
      setEmail({
        status: "warning",
        msg: t("Check the formatting of that and try again!"),
      });
      return false;
    }
    setEmail({
      status: "success",
      msg: "",
      value: email,
    });

    return true;
  };

  const submitErrCallback = (clear, code, msg) => {
    console.log(code, msg);
    if (code == 400037) {
      setIsNotice(true);
      setNotice(
        t(
          "Please log in from [BtcFX User (First Time)] at the top left of the homepage."
        )
      );
    }
    // HCaptchaComp.resetCaptcha();
  };
  const submitSuccCallback = () => {
    props.dispatch({
      type: "layout/save",
      payload: {
        forgetModal: false,
      },
    });
    setIsNotice(true);
    setNotice(
      t(
        "We have sent you an email to reset your MiPool password. It may take some time (about 5 minutes). Please wait."
      )
    );
    // HCaptchaComp.resetCaptcha();
  };

  const verifyCode = (vcode) => {
    if (!vcode) {
      setVcode({
        status: "danger",
        msg: t("Verify code is required!"),
      });
      return false;
    }

    if (!/^[0-9a-zA-Z]{6}$/.test(vcode)) {
      setVcode({
        status: "warning",
        msg: t("Only rquires 6 digits number"),
      });
      return false;
    }
    setVcode({
      status: "success",
      msg: "",
      value: vcode,
    });

    return true;
  };

  // 提交表单
  const submit = async (e) => {
    e.preventDefault();
    let values = {
      email: email.value,
      vcode: vcode.value,
      type: "pwdreset",
    };

   

    if (!email.msg && !vcode.msg && email.value && vcode.value) {
      try {
        await props.dispatch({
          type: "layout/getPwdResetLink",
          payload: values,
          errorCallback: submitErrCallback,
          successCallback: submitSuccCallback,
        });
      } catch (err) {
        console.log(err);
      }
    } else {
      console.log(!email.msg && !vcode.msg && email.value && vcode.value);
    }
  };


  // 获取验证码
  const RqstCode = async (e) => {
    e.preventDefault();
    let values = {
      email: email.value,
      type: "pwdreset",
    };



    if (!email.msg) {
      setTiming(true);
      try {
        await props.dispatch({
          type: "layout/getEmailCode",
          payload: values,
        });
        return true;
      } catch (err) {
        console.log(err);
      }
    }
    return false;
  };

  useEffect(() => {
    let timer;

    function countdown() {
      setSecond((preSecond) => {
        if (preSecond <= 1) {
          setTiming(false);
          // 重置秒数
          return COUNTDOWN_SECONDS;
        } else {
          timer = setTimeout(countdown, 1000);
          return preSecond - 1;
        }
      });
    }
    // 开始倒计时

    if (timing) {
      timer = setTimeout(countdown, 1000);
    }
    return () => clearTimeout(timer);
  }, [timing]);

  return (
    <div>
      <Row>
        <Modal
          isOpen={isNotice}
          toggle={toggle}
          className="modal-fullscreen-sm-down modal4 custom-modal"
          size="sm"
        >
          <ModalHeader toggle={isNoticeToggle.bind(null)}></ModalHeader>
          <ModalBody>{notice}</ModalBody>
          <ModalFooter className="justify-content-center">
            <Button color="primary" onClick={isNoticeToggle.bind(null)}>
              {t("OK")}
            </Button>
          </ModalFooter>
        </Modal>
        <Modal
          isOpen={forgetModal}
          toggle={toggle}
          className="modal-fullscreen-sm-down modal4 custom-modal"
          style={{ display: "block", paddingLeft: " 0px" }}
          size="lg"
        >
          <ModalBody style={{ padding: "0" }}>
            <Row>
              <Col
                md="3"
                lg="5"
                className="modal-bg-img animate__animated animate__rubberBand d-none d-sm-block"
                style={{ backgroundImage: `url(${bgimg})` }}
              ></Col>
              <Col md="9" lg="7">
                <div className="modal-bg">
                  <h3 className="font-light">{t("Forgot password")}</h3>
                  <Form className="m-t-30">
                    <Row className="row">
                      <Col lg="12">
                        <FormGroup
                          className={email.status ? "has-" + email.status : ""}
                        >
                          <Input
                            className={
                              email.status
                                ? "form-control mb-2 form-control-" +
                                  email.status
                                : "form-control mb-2 "
                            }
                            type="email"
                            placeholder={t("Email address")}
                            value={email.value}
                            onChange={onChange.bind(this, "email")}
                            onBlur={onBlur.bind(this, "email")}
                          />
                        </FormGroup>
                      </Col>

                      <Col lg="12">
                        <FormGroup
                          className={vcode.status ? "has-" + vcode.status : ""}
                        >
                          <InputGroup>
                            <Input
                              className={
                                vcode.status
                                  ? "form-control mb-2 form-control-" +
                                    vcode.status
                                  : "form-control mb-2 "
                              }
                              type="text"
                              placeholder={t("Email verification code")}
                              value={vcode.value}
                              onChange={onChange.bind(this, "vcode")}
                              onBlur={onBlur.bind(this, "vcode")}
                            />
                            <InputGroupAddon addonType="append">
                              <Button
                                onClick={RqstCode}
                                disabled={timing}
                                className="mb-2"
                                outline
                                color="info waves-effect waves-light btn-sm"
                              >
                                {timing ? `⏰ ${second}s` : t("Get code")}
                              </Button>
                            </InputGroupAddon>
                          </InputGroup>
                        </FormGroup>
                      </Col>

                      <Col className="col-lg-12 d-flex no-block justify-content-center">
                        <Button
                          type="submit"
                          className="btn btn-md btn-success-gradiant text-white btn-arrow"
                          onClick={submit}
                        >
                          <span>
                            {t("Confirm")} <i className="ti-arrow-right"></i>
                          </span>
                        </Button>{" "}
                      </Col>
                    </Row>
                  </Form>
                </div>
              </Col>
              <a
                href="#"
                className="close-btn d-flex align-items-center justify-content-center"
                data-bs-dismiss="modal"
                aria-hidden="true"
                onClick={preventJump}
              >
                ×
              </a>
            </Row>
          </ModalBody>
        </Modal>
      </Row>
    </div>
  );
};

export default ForgetModal;
